module.exports = __webpack_public_path__ + "img/hdc_hustletokens.04cd109.png";